// App-wide constants (magic numbers extracted for maintainability)

// Polling
export const PERFORMANCE_POLL_INTERVAL_MS = 6000;

// Toast timing
export const COPY_INDICATOR_MS = 1500;

// API timeouts
export const API_TIMEOUT_MS = 120000; // 2 min — LLM + image gen can be slow

// Platforms & tones
export const PLATFORMS = [
  { id: "google", label: "Google" },
  { id: "meta", label: "Meta" },
  { id: "tiktok", label: "TikTok" },
  { id: "instagram", label: "Instagram" },
  { id: "twitter", label: "X" },
  { id: "reddit", label: "Reddit" },
];

export const TONES = [
  "energetic",
  "professional",
  "playful",
  "urgent",
  "authoritative",
  "story-driven",
];

export const PLATFORM_META = {
  google: { label: "Google Ads", color: "#4285F4" },
  meta: { label: "Meta / Facebook", color: "#1877F2" },
  tiktok: { label: "TikTok", color: "#ff007f" },
  instagram: { label: "Instagram", color: "#E1306C" },
  twitter: { label: "X (Twitter)", color: "#ffffff" },
  reddit: { label: "Reddit", color: "#FF4500" },
};

export const ASPECTS = ["1:1", "9:16", "16:9"];
